export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-3-10.19db7f12.jpg";